export default {
    label_task:{
        en:"Type Calender Report",
        bn:'Variety Report'
    },
    label_month_status:{
        en:"Season Status",
        bn:'Variety Report'
    },
    label_select_all:{
        en:"Select all",
        bn:'Variety Report'
    },

}